<template>
  <div class="wrap-bullet">
    <div class="wrapper-line">
      <div class="row" key="1">
        <div class="cycle"></div>
      </div>
      <div class="dash"></div>

      <div class="row" key="2">
        <div class="cycle active">
          <div class="wrapper-detail">
            <div class="dash-detail" />
            <div class="details">
              <div class="bullet-title">ภายใน กุมภาพันธ์</div>
              <div class="bullet-link">
                ยื่นแบบ <span @click="goToDoc1a()">ภ.ง.ด. 1 ก</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dash"></div>

      <div class="row" key="3">
        <div class="cycle"></div>
      </div>
      <div class="dash"></div>

      <div class="row" key="4">
        <div class="cycle"></div>
      </div>
      <div class="dash height"></div>

      <div class="row" key="5">
        <div class="cycle active">
          <div class="wrapper-detail">
            <div class="dash-detail" />
            <div class="details">
              <div class="bullet-title">ภายใน พฤษภาคม</div>
              <div class="bullet-link">
                ยื่นแบบ <span @click="goToDoc50()">ภ.ง.ด. 50</span>
              </div>
              <div class="bullet-description">
                ยื่นภายใน 150 วัน<br />นับแต่วันสุดท้ายของรอบ<br />ระยะเวลาบัญชี
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dash height"></div>

      <div class="row" key="6">
        <div class="cycle"></div>
      </div>
      <div class="dash"></div>

      <div class="row" key="7">
        <div class="cycle"></div>
      </div>
      <div class="dash height"></div>

      <div class="row" key="8">
        <div class="cycle active">
          <div class="wrapper-detail">
            <div class="dash-detail" />
            <div class="details">
              <div class="bullet-title">ภายใน สิงหาคม</div>
              <div class="bullet-link">
                ยื่นแบบ <span @click="goToDoc51()">ภ.ง.ด. 51</span>
              </div>
              <div class="bullet-description">
                ยื่นภายใน 60 วัน<br />นับแต่วันสุดท้ายของรอบ<br />ระยะ 6 เดือน
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dash height"></div>

      <div class="row" key="9">
        <div class="cycle"></div>
      </div>
      <div class="dash"></div>

      <div class="row" key="10">
        <div class="cycle"></div>
      </div>
      <div class="dash"></div>

      <div class="row" key="11">
        <div class="cycle"></div>
      </div>
      <div class="dash"></div>

      <div class="row" key="12">
        <div class="cycle"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped>
.wrap-bullet {
  z-index: 1;
}
.wrapper-line {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}
.row {
  position: relative;
  display: flex;
}
.cycle {
  width: 20px;
  height: 20px;
  background: #99d6f1;
  border-radius: 50%;
  position: relative;
}

.dash {
  border-right: 2px solid #99d6f1;
  height: 10px;
}
.wrapper-detail {
  position: absolute;
  display: flex;
  align-items: center;
  top: 50%;
  left: 50%;
  transform: translateY(-50%);
  right: -183px;
}
.dash-detail {
  width: 20px;
  border-top: 2px solid #29a9e2;
}
.details {
  background: #29a9e2;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  min-width: 152px;
  max-width: 152px;
  white-space: nowrap;
  padding: 9px;
  box-sizing: border-box;
  color: white;
  text-align: left;
}
.active {
  border-color: #29a9e2;
  background: #29a9e2;
}
.height {
  height: 40px;
}
.bullet-title {
  font-weight: bold;
}
.bullet-link {
}
.bullet-link > span {
  text-decoration: underline;
  cursor: pointer;
}
.bullet-description {
  margin-top: 8px;
  font-weight: normal;
  font-size: 12px;
}
</style>
